import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { coreAPI_Service } from '@/lib/api/core';
import type { RichSearchSuggestions } from '@/types/catalog';

export function useSearchSuggestions(query: string, limit = 5) {
  const { i18n } = useTranslation();
  return useQuery<RichSearchSuggestions>({
    queryKey: ['searchSuggestions', query, limit, i18n.language],
    queryFn: () => coreAPI_Service.getSearchSuggestions(query, limit),
    enabled: query.length >= 2,
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 5,
  });
}
